import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, FormControl, InputLabel, OutlinedInput } from '@material-ui/core/';
import useStyles from './styles';

const CustomTextField = ({ input: { name, type, value, ...restInput }, fullWidth, id, label, meta, ...rest }) => {
  const classes = useStyles();
  const serverError = !meta.dirtySinceLastSubmit && meta.submitError;
  const isError = (meta.error || serverError) && (meta.touched || meta.submitFailed);

  return (
    <FormControl {...restInput} fullWidth={fullWidth} error={isError}>
      <InputLabel className={classes.label} shrink htmlFor={id}>
        {label}
      </InputLabel>
      <OutlinedInput
        id={id}
        className={classes.inputField}
        name={name}
        type={type}
        value={value ?? ''}
        {...rest}
        {...restInput}
      />
      {isError && (
        <FormHelperText id="outlined-weight-helper-text" error>
          {meta.error || serverError}
        </FormHelperText>
      )}
    </FormControl>
  );
};

CustomTextField.defaultProps = {
  fullWidth: false,
};

CustomTextField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape().isRequired,
  id: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
};

export default CustomTextField;
